import { createSelector } from 'reselect'
import getCurrentMemberFirstName from 'modules/squad/redux/selectors/get-current-member-first-name'
import getTitleMostPopularSuperLikedSampleSelectUtil from 'pages/Squad/containers/Friends/CurrentFriendSampleSummary/Content/MostPopularSuperLikedSampleAndMostRecentLike/MostPopularSuperLikedSample/selectors/get-title/utils'

const getTitleMostPopularSuperLikedSampleSelect = createSelector(
  getCurrentMemberFirstName,
  memberFirstName => getTitleMostPopularSuperLikedSampleSelectUtil(memberFirstName)
)

export default getTitleMostPopularSuperLikedSampleSelect
